/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { Box, FlexContainer, Radio, Text, theme } from "@nordcloud/gnui";
import { ApprovalMode } from "~/generated/graphql";
import { RadioLabel } from "~/components/Styled";
import { approvalModeOptions } from "~/constants/approvalMode";
import { FormField } from "~/views/plans/PlanCreate/components/PlanCreateWizard/types";

type Props = {
  value?: ApprovalMode;
  onChange: (value: ApprovalMode) => void;
};

export function ApprovalModeRadio({ value, onChange }: Props) {
  return (
    <Box boxStyle="lightGrey" innerSpacing="spacing03">
      <FlexContainer
        direction="column"
        gap={theme.spacing.spacing04}
        role="radiogroup"
        aria-label="Approval Mode"
      >
        {approvalModeOptions.map((option) => (
          <ApprovalModeOption key={option.value} htmlFor={option.value}>
            <Radio
              id={option.value}
              name={FormField.APPROVAL_MODE}
              labelText={
                <ApprovalModeOptionText>
                  <Text tag="span">{option.label}</Text>
                  <Text
                    tag="span"
                    size="sm"
                    css={{ color: theme.color.text.text02 }}
                  >
                    {option.description}
                  </Text>
                </ApprovalModeOptionText>
              }
              value={option.value}
              onChange={() => onChange(option.value)}
              checked={option.value === value}
            />
          </ApprovalModeOption>
        ))}
      </FlexContainer>
    </Box>
  );
}

const ApprovalModeOption = styled(RadioLabel)`
  justify-content: flex-start;
  padding: 0;
  width: 100%;

  > div {
    align-items: flex-start;
    margin-bottom: 0;
  }

  > div > div:first-child {
    margin-top: 2px;
  }

  > div > label {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.spacing01};
    margin-top: -2px;
  }
`;

const ApprovalModeOptionText = styled.span`
  display: flex;
  flex-direction: column;
`;
